import * as React from "react";
export const ParametroPortalBottom = () => {
  return (
    <React.Fragment>
      <div></div>
    </React.Fragment>
  );
};
